export enum Icons {
  Return = 'reply',
  Sport = 'sport',
  Team = 'equipe',
  Warning = 'warning',
  Delete = 'delete',
  Computation = 'trending_up',
  Save = 'arrow_forward_ios',
  Dimensions = 'line_weight',
  Error = 'error',
  Copy = 'copy'
}
